export const ERROR_FETCH_CATEGORIES = 'Can\'t load categories';
export const ERROR_UPDATE_CATEGORY = 'Can\'t update category';
export const ERROR_UPLOAD_CATEGORY_IMAGE = 'Can\'t upload category image';
export const ERROR_CREATE_CATEGORY = 'Can\'t create category';
export const ERROR_UPLOAD_BANNER_IMAGE = 'Maximum banner\'s size is 3mb';
export const PASSWORD_ERROR = 'Password must include 8 characters: a-z, A-Z, 0-9';
